import { render, staticRenderFns } from "./newForm.vue?vue&type=template&id=22bf03ee&scoped=true&"
import script from "./newForm.vue?vue&type=script&lang=js&"
export * from "./newForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf03ee",
  null
  
)

export default component.exports